import { useCampaignClient } from '@/lib/api'
import { invalidateCampaignQueries } from '@/lib/cache-utils'
import {
  CampaignDetailsFormSchema,
  CreateCampaignSchema,
  UpdateCampaignDetailsType,
} from '@/schema/campaign-details.schema'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect } from 'react'
import { SubmitHandler } from 'react-hook-form'
import { useNavigate, useOutletContext, useParams } from 'react-router-dom'
import { useSetRecoilState } from 'recoil'
import { GetCampaignFragment } from '@/types/campaign'
import { activeStepState } from '../../../store/atoms/active-step'
import CampaignDetailsForm from './form'

export default function UpdateCampaignDetails() {
  const { id } = useParams()
  const { campaign } = useOutletContext<{ campaign: GetCampaignFragment }>()
  const queryClient = useQueryClient()
  const campaignClient = useCampaignClient()

  const setActiveStep = useSetRecoilState(activeStepState)
  const navigate = useNavigate()
  useEffect(() => setActiveStep(1), [setActiveStep])
  if (!id || !campaign) return <p>Missing id</p>

  const updateCampaignMutation = useMutation({
    mutationFn: (data: UpdateCampaignDetailsType) =>
      campaignClient.updateCampaignDetails.mutate({
        params: { id },
        body: { ...data, id },
      }),
  })

  const onSubmit: SubmitHandler<UpdateCampaignDetailsType> = (data, e) => {
    const buttonName = (
      (e?.nativeEvent as SubmitEvent) || undefined
    )?.submitter?.getAttribute('name')

    updateCampaignMutation.mutate(data, {
      onSuccess: (response) => {
        if (response.status === 200) {
          invalidateCampaignQueries(queryClient, id)

          if (buttonName === 'next') {
            navigate(`/campaigns/questionnaire/${id}`)
          }
        }
      },
      onError: (error) => {
        console.error('Failed to update campaign:', error)
      },
    })
  }

  return (
    <CampaignDetailsForm
      values={CampaignDetailsFormSchema.parse(campaign)}
      onSubmit={onSubmit}
      schema={CreateCampaignSchema}
    />
  )
}
